import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './set_premium_templates.component.html'
})
export class SetPremiumTemplatesModalComponent extends BaseSupportModalComponent {
	userId: string;
	templates: string[];
	userTemplates: string[];

	async ok() {
		await this.supportService.setSptuDetail(this.userId, this.userTemplates, this.spreader.base.comment).toPromise();

		this.execute();
	}
}
